//export const NAME_REGEX = /^[a-zA-Z ]*$/;
export const NAME_REGEX = /^([^0-9]*)$/;
export const NAME_MESSAGE = "Name is invalid"